export enum Domain {
  USER_RESOURCES = 'USER_RESOURCES',
  PATIENT_STUDY_JOURNEY = 'PATIENT_STUDY_JOURNEY',
  VISIT_DESCRIPTION = 'VISIT_DESCRIPTION',
}
